import { connect } from 'react-redux';
import Lightbox from '../../components/Shortlist/ShortlistFailureLightbox';
import { closeShortlistFailureLightbox } from '../../actions/shortlist';

export default connect(
    state => ({ open: state.shortlist.shortlistFailureLightbox }),
    { onClose: closeShortlistFailureLightbox }
)(Lightbox);



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/ShortlistFailureLightbox.js